var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label-for":"input-horizontal","label-cols-sm":"4","label":_vm.label,"label-size":"sm","label-align":"right"}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.options,"stacked":""},model:{value:(_vm.vValue),callback:function ($$v) {_vm.vValue=$$v},expression:"vValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }